import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";

const CommonModal = (props) => {
  const {
    // state
    commonModalReducer,

    // component
    children,
    className = "",
  } = props;

  const modalSize = commonModalReducer?.size ?? "sm";

  const closeModal = () => {
    props.setCommonModal();
  };

  return (
    <Transition appear show={commonModalReducer?.state} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}} static>
        {/* --- Back drop --- */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-75"
          leave="ease-in duration-200"
          leaveFrom="opacity-75"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75" />
        </Transition.Child>

        {/* --- Content --- */}
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div
            className={`flex min-h-full items-center justify-center text-center${
              !_.isEqual(modalSize, "screen") ? " p-4" : ""
            }`}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative transform overflow-hidden rounded-lg bg-white px-4- pb-4- pt-5- text-left shadow-xl transition-all sm:w-full ${
                  _.isEqual(modalSize, "screen")
                    ? "w-screen h-screen"
                    : _.isEqual(modalSize, "lg")
                    ? "max-w-screen-lg"
                    : "max-w-sm"
                } ${!_.isEqual(modalSize, "screen") ? "sm:my-8" : ""} sm:p-6-`}
              >
                {/* - Children component - */}
                <div className={`${className}`}>{children}</div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

CommonModal.header = (props) => {
  const { children, className } = props;

  return <header className={className}>{children}</header>;
};

CommonModal.main = (props) => {
  const { children, className } = props;

  return <main className={className}>{children}</main>;
};

CommonModal.footer = (props) => {
  const { children, className } = props;

  return <footer className={className}>{children}</footer>;
};

const mapStateToProps = (state) => {
  return {
    commonModalReducer: state.commonModalReducer,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CommonModal);
